export default "__VITE_ASSET__Bq8oIOvo__"